import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './component/Home';
import Dashboard from './component/Dashboard';
import UserRegistration from './component/UserRegistration';
import { HashRouter } from 'react-router-dom'
import OTP from './component/OTP';
import Preview from './component/Preview';
import FinalSubmit from './component/FinalSubmit';
import ReferenceId from './component/ReferenceId';
import UserDashboard from './component/UserDashboard';
import ForgotPassword from './component/ForgotPassword';
import ResetPassword from './component/ResetPassword';
import FirstPage from './component/FirstPage';
import PreviewBeforeSubmit from './component/PreviewBeforeSubmit';


function App() {
  return (
    <div className="App">
      {/* <BrowserRouter basename="/gstat-application"> 
      
          <Routes> 
            <Route path="/" element={<Home />}> </Route>
            <Route path="/registration" element={<Dashboard />}> </Route>
            <Route path="/user-registration" element={<UserRegistration/>}> </Route>
            <Route path="*" element={<Home />}> </Route>
          </Routes> 
      </BrowserRouter>  */}
      <HashRouter>
      <Routes> 
        <Route
          path='/'
          element={<FirstPage/>}
        />
        <Route
          path='/login'
          element={<Home/>}
        />
        <Route
      
          path='/registration'
          element={<Dashboard/>}
        />
         <Route
      
      path='/user-dashboard'
      element={<UserDashboard/>}
    />
        <Route
      
      path='/reference-id'
      element={<ReferenceId/>}
    />
    <Route
      
      path='/forgot-password'
      element={<ForgotPassword/>}
    />
    <Route
      
      path='/reset-password'
      element={<ResetPassword/>}
    />
    <Route
      
      path='/preview-before-sumbit'
      element={<PreviewBeforeSubmit/>}
    />
        <Route
      
      path='/preview'
      element={<Preview/>}
    />
        <Route
          path='/otp'
          element={<OTP/>}
        />
        <Route
          
          path='/user-registration'
          element={<UserRegistration/>}
        />
        <Route
          path='*'
          element={<Home/>}
        />
        </Routes>
  </HashRouter>
    </div>
  );
}

export default App;
